var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#F6AF62;} .st1{fill:#DB7767;} .st2{fill:#F6AF62;} .st3{fill:#FFFFFF;} .st4{fill:#F6AF62;} .st5{fill:#DB7767;} .st6{fill:#DB7767;} .st7{fill:#DB7767;} .st8{fill:#F6AF62;} .st9{fill:#F6AF62;} .st10{fill:#F6AF62;} .st11{fill:#F6AF62;} .st12{fill:#F6AF62;} .st13{fill:#F6AF62;} .st14{fill:#CE6B61;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.02,20.15v19.77c4.09-1.43,7.03-5.31,7.03-9.89S47.11,21.58,43.02,20.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.33,36.99l2.45,14.33c0.18,0.94,1.01,1.63,1.97,1.63c0.96,0,1.79-0.68,1.97-1.63l2.45-14.33H16.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.95,23.09C11.11,23.09,8,26.2,8,30.04s3.11,6.95,6.95,6.95h1.38v-13.9H14.95z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.18,36.99 43.89,47.65 43.89,12.44 25.18,23.09 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.89,11.05c-0.84,0-1.52,0.68-1.52,1.52v34.95c0,0.84,0.68,1.52,1.52,1.52c0.84,0,1.52-0.68,1.52-1.52V12.57 C45.41,11.73,44.73,11.05,43.89,11.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.48,29.52h-3.54c-0.29,0-0.52,0.23-0.52,0.52s0.23,0.52,0.52,0.52h3.54c0.29,0,0.52-0.23,0.52-0.52 S55.77,29.52,55.48,29.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.27,34.71c-0.2-0.2-0.53-0.2-0.74,0s-0.2,0.53,0,0.74l2.5,2.5c0.2,0.2,0.53,0.2,0.74,0 c0.2-0.2,0.2-0.53,0-0.74L51.27,34.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.27,25.37l2.5-2.5c0.2-0.2,0.2-0.53,0-0.74c-0.2-0.2-0.53-0.2-0.74,0l-2.5,2.5c-0.2,0.2-0.2,0.53,0,0.74 C50.73,25.58,51.06,25.58,51.27,25.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.02,25.93c-0.29,0-0.52,0.23-0.52,0.52s0.23,0.52,0.52,0.52h3.54v-1.04H13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.02,28.32c-0.29,0-0.52,0.23-0.52,0.52s0.23,0.52,0.52,0.52h3.54v-1.04H13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.02,30.72c-0.29,0-0.52,0.23-0.52,0.52s0.23,0.52,0.52,0.52h3.54v-1.04H13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.02,33.11c-0.29,0-0.52,0.23-0.52,0.52s0.23,0.52,0.52,0.52h3.54v-1.04H13.02z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 13.9,
    width: 8.85,
    x: 16.33,
    y: 23.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.77070d5400f07de358c33fc0a10ee584.svg";
export { ForwardRef as ReactComponent };